import React from 'react'
import ButtonCard from 'Components/ButtonCard'
import { useLocation } from 'react-router-dom'
import User from 'Hooks/user'

const data = [
  { link: '/procurement/vendor-payments', title: 'Invoices' },
  { link: '/procurement/vendor-payments/pending', title: 'Payments Pending Authorisation' },
  { link: '/procurement/vendor-payments/authorised', title: 'Payments Authorised' },
  { link: '/procurement/vendor-payments/declined', title: 'Payments Declined' },
  { link: '/procurement/vendor-payments/final-approval', title: 'Final Approval' },
]

function MenuButton(props) {
  const location = useLocation();
  const { userRoles } = User();
  const isFinanceOrQC = userRoles.includes(8) || userRoles.includes(9);

  const visibleData = isFinanceOrQC
    ? data.filter(v => v.link === '/procurement/vendor-payments/final-approval')
    : data.filter(v => v.link !== '/procurement/vendor-payments/final-approval');

  return (
    <div style={{ display: 'flex' }} >
      {visibleData.map(v => (<ButtonCard
        key={v.link}
        link={v.link}
        title={v.title}
        lightBlue
        selected={location.pathname === v.link}
      />))}
    </div>
  )
}

MenuButton.propTypes = {}

export default MenuButton
